export const capitalizeEveryWord = (str: string) => {
  // Split the string into an array of words based on spaces
  const words = str.split(' ')

  // Use map to iterate over each word in the array
  const capitalizedWords = words.map((word) => {
    // Capitalize the first character and add the rest of the word
    if (word.length > 0) {
      return word.charAt(0).toUpperCase() + word.slice(1)
    }
    return word // Return empty strings as they are
  })

  // Join the capitalized words back into a single string with spaces
  return capitalizedWords.join(' ')
}
